<template>
  <div class="dynamic-menu-tree">
    <template v-for="node in sortedNodes">
      <el-submenu
        v-if="showNode(node) && hasChildren(node)"
        :key="`sub-${node.id}`"
        :index="node.pathUrl || `menu-${node.id}`"
        :class="{ sub: level > 0 }"
      >
        <template slot="title">
          <span class="menu-label" :style="{ paddingLeft: `${12 + level * 20}px` }">{{
            node.name
          }}</span>
        </template>
        <DynamicMenuTree :nodes="node.children || []" :level="level + 1" />
      </el-submenu>

      <el-menu-item
        v-else-if="showNode(node) && node.pathUrl"
        :key="`item-${node.id}`"
        :index="node.pathUrl"
        :style="{ paddingLeft: `${24 + level * 20}px` }"
      >
        <span>{{ node.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "DynamicMenuTree",
  props: {
    nodes: {
      type: Array,
      default: () => [],
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    sortedNodes() {
      const normalize = (list) => {
        const safeList = Array.isArray(list) ? list.slice() : [];
        safeList.sort((a, b) => {
          const sa = Number(a && a.sort);
          const sb = Number(b && b.sort);
          if (Number.isFinite(sa) && Number.isFinite(sb)) return sa - sb;
          if (Number.isFinite(sa)) return -1;
          if (Number.isFinite(sb)) return 1;
          return 0;
        });
        return safeList.map((item) => ({
          ...item,
          children: normalize(item && item.children),
        }));
      };
      return normalize(this.nodes);
    },
  },
  methods: {
    hasChildren(node) {
      return node && node.children && node.children.length > 0;
    },
    showNode(node) {
      return !!(node && node.name);
    },
  },
};
</script>

<style scoped>
.dynamic-menu-tree {
  display: contents;
}

.menu-label {
  display: inline-block;
  width: calc(100% - 24px);
  box-sizing: border-box;
}
</style>
